import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "../i18n";
import { useSeo } from "../hooks/useSeo";
import { pathFor } from "../config/site";
import { IMAGES } from "../data/structure";
import { webpageLd, articleLd, breadcrumbLd, personLd } from "../lib/jsonld";
import PageHero from "../components/PageHero";
import { Section } from "../components/Section";
import OfficialLinks from "../components/OfficialLinks";

export default function StylePage({ pageKey }) {
  const { lang, d } = useI18n();
  const meta = d.meta.style;
  const points = [d.impactSection.points[3], d.impactSection.points[4]];

  useSeo({
    pageKey,
    title: meta.title,
    description: meta.description,
    jsonLd: [
      webpageLd({ lang, pageKey, title: meta.title, description: meta.description }),
      articleLd({ lang, pageKey, headline: d.pillars.fashion.title, description: meta.description }),
      personLd(),
      breadcrumbLd([
        { name: d.ui.nav.home, path: pathFor(lang, "home") },
        { name: d.ui.nav.style, path: pathFor(lang, "style") },
      ]),
    ],
  });

  return (
    <>
      <PageHero testid="style-hero" kicker={d.pillars.fashion.title} title={d.meta.style.title.split(" |")[0]} intro={d.pages.style.intro} image={IMAGES.redCarpet} />
      <Section>
        <div className="max-w-3xl">
          <p className="text-lg text-jlo-warm/85 leading-relaxed">{d.pillars.fashion.body}</p>
        </div>
        <div className="mt-12 grid gap-5 sm:grid-cols-2">
          {points.map((pt, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.45, delay: i * 0.06 }} className="glass rounded-2xl p-6" data-testid={`style-point-${i}`}>
              <h3 className="font-display text-xl font-semibold text-jlo-warm">{pt.title}</h3>
              <p className="mt-2 text-sm text-jlo-warm/70 leading-relaxed">{pt.body}</p>
            </motion.div>
          ))}
        </div>
      </Section>
      <OfficialLinks />
    </>
  );
}
